import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout";
Vue.use(Router);

const [MEMBER, ADMIN, SUPERADMIN, MASTER, SHIPPOP] = [
  "member",
  "admin",
  "superadmin",
  "master",
  "shippop",
];
const [PATH_DROPOFF, PATH_WALLET] = [
  "./views/Report/Dropoff/",
  "./views/Wallet/",
];

let router = new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "demo" */ "./views/Login.vue"),
      meta: {
        guest: true,
      },
    },
    {
      path: "/pos",
      name: "pos",
      component: () => import(/* webpackChunkName: "demo" */ "./views/Pos.vue"),
      meta: {
        requiresAuth: true,
        role: [MEMBER, ADMIN],
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: () =>
        import(/* webpackChunkName: "demo" */ "./views/logout.vue"),
      meta: {
        requiresAuth: true,
        role: [],
      },
    },
    {
      path: "/improve",
      name: "improve",
      component: () =>
        import(/* webpackChunkName: "demo" */ "./views/ImproveSystem.vue"),
      meta: {
        requiresAuth: true,
        role: [MEMBER, ADMIN, SUPERADMIN, SHIPPOP],
      },
    },
    {
      path: "/label/:labelId/:size",
      name: "label",
      component: () =>
        import(/* webpackChunkName: "demo" */ "./views/LabelHtml.vue"),
      meta: {
        requiresAuth: true,
        role: [MEMBER, ADMIN, SUPERADMIN],
      },
      children: [
        {
          path: "/label/:labelId/:size/:type",
          name: "labeldropoffshippop",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/LabelHtml.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN, SUPERADMIN],
          },
        },
        {
          path: "/label/:type/:orderId/:detailId/:label",
          name: "customlabel",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/LabelHtml.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN, SUPERADMIN],
          },
        },
      ],
    },
    {
      path: "/receipt/:receiptId",
      name: "receipt",
      component: () =>
        import(/* webpackChunkName: "demo" */ "./views/Receipt.vue"),
      meta: {
        requiresAuth: true,
        role: [MEMBER, ADMIN, SUPERADMIN],
      },
    },
    {
      path: "/delivery/:deliveryId",
      name: "delivery",
      component: () =>
        import(/* webpackChunkName: "demo" */ "./views/Delivery.vue"),
      meta: {
        requiresAuth: true,
        role: [MEMBER, ADMIN, SUPERADMIN],
      },
    },
    {
      path: "/report",
      name: "report",
      redirect: "/",
      component: DashboardLayout,
      children: [
        {
          path: "dropoff",
          name: "dropoff",
          component: () => import(PATH_DROPOFF + "Orders.vue"),
          meta: {
            requiresAuth: true,
            role: [SHIPPOP, SUPERADMIN, ADMIN],
          },
        },
        {
          path: "wallet/shops",
          name: "walletshops",
          component: () => import(PATH_WALLET + "SuperAdmin/ReportBrance.vue"),
          meta: {
            requiresAuth: true,
            role: [SHIPPOP, MASTER, SUPERADMIN],
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "dashboard",
      component: DashboardLayout,
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Dashboard.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "cancelorders/:orderId",
          name: "cancelorders",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/CancelOrders.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "dashboardshippop",
          name: "dashboardshippop",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Dashboardshippop.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [SUPERADMIN],
          },
        },
        {
          path: "product",
          name: "product",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Product.vue"),
          meta: {
            requiresAuth: true,
            role: [ADMIN],
          },
        },
        {
          path: "profile",
          name: "profile",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/UserProfile.vue"),
        },
        {
          path: "usersmanage",
          name: "usersmanage",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/UsersManage.vue"),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SHIPPOP],
          },
        },
        {
          path: "/transports",
          name: "transportmanage",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/TransportManage.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN, SHIPPOP],
          },
        },
        {
          path: "/transport",
          name: "transport",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/TransportEdit.vue"),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN, SHIPPOP],
          },
          children: [
            {
              path: "/transport/:Id",
              name: "transportedit",
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "./views/TransportEdit.vue"
                ),
              meta: {
                requiresAuth: true,
                role: [SUPERADMIN, ADMIN, SHIPPOP],
              },
            },
          ],
        },
        {
          path: "/brancemanage",
          name: "brancemanage",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Brance.vue"),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN, SHIPPOP],
          },
        },
        {
          path: "/branceedit/:Id",
          name: "branceedit",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/BranceEdit.vue"),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN, SHIPPOP],
          },
        },
        // {
        //   path: "/agentmanage",
        //   name: "agentmanage",
        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "./views/AgentManage.vue"),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SHIPPOP],
        //   },
        // },
        {
          path: "/branceedit/",
          name: "adminbranceedit",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/BranceEdit.vue"),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN],
          },
        },
        {
          path: "/reporttransport",
          name: "reporttransport",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportTransport.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/reportbrance",
          name: "reportbrance",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportBrance.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN, MASTER, SHIPPOP],
          },
        },
        {
          path: "/reportcod",
          name: "reportcod",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportCod.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN, SUPERADMIN, SHIPPOP],
          },
        },
        {
          path: "/reportcod/:Id",
          name: "reportcodmember",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportCod.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/reportpos",
          name: "reportpos",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportPos.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN, SHIPPOP], // superadmin
          },
        },
        {
          path: "/reportproduct",
          name: "reportproduct",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportProduct.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/reportdropoffshippop",
          name: "reportdropoffshippop",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportDropoffShippop.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/reportshippop",
          name: "reportshippop",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportShippop.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [ADMIN, SUPERADMIN, SHIPPOP], // superadmin
          },
        },
        {
          path: "/exportdelivery",
          name: "exportdelivery",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/ExportDelivery.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/reportdelivery",
          name: "reportdelivery",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Report/ReportDelivery.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/registermember",
          name: "registermember",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/RegisterMember.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/registermember/:email",
          name: "registermemberbyemail",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/RegisterMember.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/confirmCommissionSPAdmin",
          name: "confirmCommissionSPAdmin",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/ReportVerifyShop/ConfirmShopsCommissionSPAdmin.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [SUPERADMIN],
          },
        },
        {
          path: "/resgisterCommission",
          name: "resgisterCommission",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/RegisterCommission.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [SUPERADMIN],
          },
        },
        {
          path: "/verify/:Id",
          name: "dataverrify",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/ShowDataVerrify.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [SUPERADMIN, SHIPPOP],
          },
        },
        {
          path: "/verify/shippop/:UserId",
          name: "verrifyshippop",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/ShowDataVerrify.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [SUPERADMIN, SHIPPOP],
          },
        },
        {
          path: "/usershop",
          name: "usershop",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/UserShop.vue"),
          meta: {
            requiresAuth: true,
            role: [SHIPPOP],
          },
        },
        {
          path: "/membershop",
          name: "membershop",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Member.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        {
          path: "/flefixparcel",
          name: "flefixparcel",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/FlashFixParcel.vue"),
          meta: {
            requiresAuth: true,
            role: ["member", "admin"],
          },
        },
        {
          path: "/shop/commission",
          name: "shopcommission",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/ShopCommission.vue"),
          meta: {
            requiresAuth: true,
            role: [SHIPPOP],
            // member , admin
          },
        },
        {
          path: "/superadmin/commission",
          name: "superadmincommission",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/SuperAdminCommission.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [SHIPPOP],
            // member , admin
          },
        },
        {
          path: "/membercod",
          name: "membercod",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/MemberCod.vue"),
          meta: {
            requiresAuth: true,
            role: [SHIPPOP],
          },
        },
        {
          path: "/memberedit/:Id",
          name: "memberedit",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/MemberCodEdit.vue"),
          meta: {
            requiresAuth: true,
            role: [SHIPPOP],
          },
        },
        // {
        //   path: '/createbill/',
        //   name: 'createbill',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/Report/Cod/CreateBill.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SHIPPOP]
        //   }
        // },
        {
          path: "/historycancel",
          name: "historycancel",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/HistoryCancel.vue"),
          meta: {
            requiresAuth: true,
            role: [MEMBER, ADMIN],
          },
        },
        // {
        //   path: "/changelog",
        //   name: "changelog",
        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "./views/ChangeLog.vue"),
        //   meta: {
        //     requiresAuth: true,
        //     role: [ADMIN, SHIPPOP],
        //   },
        // },
        // {
        //   path: "/topupcredit",
        //   name: "topupcredit",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/Admin/TopUpCredit.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [ADMIN],
        //   },
        // },
        // {
        //   path: "/history/topupwallet",
        //   name: "historytopupwallet",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/Admin/HistoryTopUpWallet.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [ADMIN],
        //   },
        // },
        // {
        //   path: "/history/usagewallet",
        //   name: "historyusagewallet",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/Admin/HistoryUsageWallet.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [ADMIN],
        //   },
        // },
        // {
        //   path: '/notification/topupcredit',
        //   name: 'notificationtopupcredit',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/Wallet/SuperAdmin/NotificationTopUpCredit.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SUPERADMIN]
        //   }
        // },
        // {
        //   path: "/history/usagewallet/superadmin",
        //   name: "historyusagewalletsuperadmin",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/HistoryUsageWallet.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SUPERADMIN],
        //   },
        // },
        // {
        //   path: "/withdraw/credit",
        //   name: "withdrawcredit",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/WithDrawCredit.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SUPERADMIN],
        //   },
        // },
        // {
        //   path: "/topupcredit/shop",
        //   name: "topupcredittoshop",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/TopUpCreditToShop.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SUPERADMIN],
        //   },
        // },
        // {
        //   path: "/history/topupcredit/superadmin",
        //   name: "historytopupwallettoshop",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/HistoryTopUpWalletToShop.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SUPERADMIN],
        //   },
        // },
        // {
        //   path: "/creditbalance/shop",
        //   name: "creditbalanceshop",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/CreditBalanceShop.vue"
        //     ),
        //   meta: {
        //     requiresAuth: true,
        //     role: [SUPERADMIN],
        //   },
        // },
        {
          path: "/reportoverweight",
          name: "reportoverweight",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/ReportOverWeight.vue"
            ),
          meta: {
            requiresAuth: true,
            role: [SUPERADMIN],
          },
        },
        {
          path: "/ratemanagement/:Id",
          name: "ratemanagement",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/RateManagement.vue"),
          meta: {
            requiresAuth: true,
            role: [SUPERADMIN, SHIPPOP],
          },
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("access_token") == null) {
      next({
        path: "/login",
        params: {
          nextUrl: to.fullPath,
        },
      });
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        let role = user.role;
        let token_expire = user.exp;
        if (token_expire <= Date.now() / 1000) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          next({
            path: "login",
          });
        } else if (
          ("role" in to.meta && to.meta.role.includes(role) && to.meta.role) ||
          to.name == "logout"
        ) {
          next();
        } else {
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          next({
            path: "login",
          });
        }
      } else {
        localStorage.removeItem("access_token");
        next({
          path: "login",
        });
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem("access_token") == null) {
      next();
    } else {
      next({
        path: "/",
      });
    }
  } else {
    next({ path: "/" });
  }
});

export default router;
